import { render, staticRenderFns } from "./AddEditPromotion.vue?vue&type=template&id=2db6e786&scoped=true&"
import script from "./AddEditPromotion.vue?vue&type=script&lang=ts&"
export * from "./AddEditPromotion.vue?vue&type=script&lang=ts&"
import style0 from "./AddEditPromotion.vue?vue&type=style&index=0&id=2db6e786&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db6e786",
  null
  
)

export default component.exports